<template>
    <div class="user-consume">
        <Table border :columns="list" ref="userList" :data="tablelist" :loading="dataloading"></Table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page ref="listPage" :total="pages.total" :current="pages.page" :page-size="pages.size" show-elevator show-total @on-change="changePage()"></Page>
            </div>
    </div>
    </div>
</template>

<script>
    export default {
        name: "user-consume",
        data() {
            return {
                tablelist: [],
                pages: {
                    page: 1,
                    size: 10,
                    total: 0
                },
                id: 0,
                dataloading:false,
                loading:false,
                list: [
                    {
                        title: 'Id',
                        key: 'uuid',
                        width: 270,
                        fixed: 'left'
                    },
                    {
                        title: '备注',
                        minWidth: 120,
                        key: 'mark',
                    },
                    {
                        title: '金额变动情况',
                        width: 150,
                        render: (h, params) => {
                            var fh = params.row.type ==0 ?'-':'+'
                            return h('span', {}, (fh+params.row.price));
                        }
                    },
                    {
                        title: '消费时间',
                        width: 150,
                        key: 'created_at'
                    },
                ],
            }
        },
        created: function () {
            this.id = this.$route.params.id;
            // 取数据
            this.getTableList();
        },
        methods: {
            getTableList: function () {
                var params = {
                    id: this.id,
                    page: this.pages.page,
                    size: this.pages.size
                }
                this.$api.user.consumelist(params).then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        this.tablelist = res.result.list;
                        this.pages.total = res.result.total;
                        this.$Message.success(res.msg);
                    }
                });
                return;
            },
            // 翻页
            changePage() {
                this.pages.page = this.$refs['listPage'].currentPage;
                this.renderTable(1);
            },
            // 筛选
            renderTable: function (name) {
                if (name != 1) {
                    this.pages.page = 1;
                }
                var ps = {
                    "page": this.pages.page,
                    "size": this.pages.size,
                    "id": this.id,
                };
                this.$api.user.consumelist(ps).then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        this.tablelist = res.result.list;
                        this.pages.total = res.result.total;
                        this.$Message.success(res.msg);
                    }
                });
                return;
            },
        }
    }
</script>

<style scoped>

</style>